export default {"src":"/_next/static/media/0x4da27a545c0c5B758a6BA100e3a049001de870f5.fe3f744c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};